var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 56,
    viewBox: "0 0 34 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Red Pin",
    filter: "url(#filter0_d_3549_10785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5",
    d: "M16.043 33.6699L19.2332 33.4003C19.2332 33.4003 18.9199 47.0889 18.7734 47.6408C18.627 48.1928 16.043 33.6699 16.043 33.6699Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 4",
    d: "M28.4683 24.7521C28.6452 26.8452 27.591 28.898 25.6315 30.5223C23.6736 32.1451 20.8488 33.302 17.6185 33.575C14.3883 33.848 11.4094 33.1816 9.20694 31.9103C7.00254 30.638 5.61881 28.7912 5.44192 26.6981C5.26502 24.6051 6.31919 22.5523 8.27878 20.928C10.2366 19.3052 13.0614 18.1482 16.2917 17.8752C19.522 17.6022 22.5009 18.2687 24.7033 19.5399C26.9077 20.8123 28.2914 22.659 28.4683 24.7521Z",
    fill: "#E23724",
    stroke: "#CA0000",
    strokeWidth: 1.05039
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3",
    d: "M20.3621 25.8878C20.6552 29.3561 17.6126 32.4449 13.5662 32.7869C9.51986 33.1289 6.29312 29.9683 6 26.5C5.70688 23.0317 8.45838 20.569 12.5047 20.227C16.5511 19.8851 20.0689 22.4195 20.3621 25.8878Z",
    fill: "#EB7654"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_3549_10785",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7952 14.773L10.282 15.746L11.1397 25.8947C11.1408 25.9136 11.1421 25.9325 11.1437 25.9514C11.1453 25.9703 11.1472 25.9891 11.1493 26.0079L11.1855 26.4369L11.243 26.432C11.7811 28.047 14.2875 29.1116 17.1878 28.8665C20.0881 28.6214 22.3803 27.1512 22.6398 25.4688L22.6988 25.4638L21.7952 14.773Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7952 14.773L10.282 15.746L11.1397 25.8947C11.1408 25.9136 11.1421 25.9325 11.1437 25.9514C11.1453 25.9703 11.1472 25.9891 11.1493 26.0079L11.1855 26.4369L11.243 26.432C11.7811 28.047 14.2875 29.1116 17.1878 28.8665C20.0881 28.6214 22.3803 27.1512 22.6398 25.4688L22.6988 25.4638L21.7952 14.773Z",
    fill: "#E23724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.282 15.746L10.1936 14.6994L9.14692 14.7878L9.23538 15.8345L10.282 15.746ZM21.7952 14.773L22.8419 14.6846L22.7534 13.6379L21.7068 13.7264L21.7952 14.773ZM11.1397 25.8947L12.1884 25.8352L12.1876 25.8207L12.1864 25.8063L11.1397 25.8947ZM11.1493 26.0079L12.196 25.9194L12.1947 25.905L12.1931 25.8906L11.1493 26.0079ZM11.1855 26.4369L10.1389 26.5253L10.2274 27.572L11.274 27.4835L11.1855 26.4369ZM11.243 26.432L12.2395 26.1L11.9782 25.3157L11.1545 25.3854L11.243 26.432ZM22.6398 25.4688L22.5513 24.4222L21.7276 24.4918L21.6017 25.3087L22.6398 25.4688ZM22.6988 25.4638L22.7872 26.5105L23.8339 26.422L23.7454 25.3754L22.6988 25.4638ZM10.3705 16.7927L21.8837 15.8197L21.7068 13.7264L10.1936 14.6994L10.3705 16.7927ZM12.1864 25.8063L11.3287 15.6576L9.23538 15.8345L10.0931 25.9832L12.1864 25.8063ZM12.1904 25.8629C12.1896 25.8536 12.189 25.8444 12.1884 25.8352L10.091 25.9543C10.0927 25.9828 10.0947 26.0113 10.0971 26.0398L12.1904 25.8629ZM12.1931 25.8906C12.1921 25.8814 12.1912 25.8722 12.1904 25.8629L10.0971 26.0398C10.0995 26.0684 10.1023 26.0968 10.1055 26.1252L12.1931 25.8906ZM12.2322 26.3484L12.196 25.9194L10.1026 26.0963L10.1389 26.5253L12.2322 26.3484ZM11.1545 25.3854L11.0971 25.3902L11.274 27.4835L11.3314 27.4787L11.1545 25.3854ZM17.0994 27.8198C15.7928 27.9303 14.6123 27.741 13.7314 27.3763C12.8263 27.0016 12.3752 26.5074 12.2395 26.1L10.2464 26.764C10.6488 27.9716 11.72 28.8172 12.9278 29.3173C14.1597 29.8273 15.6826 30.0478 17.2763 29.9131L17.0994 27.8198ZM21.6017 25.3087C21.5362 25.7332 21.1745 26.296 20.3451 26.8173C19.5379 27.3247 18.406 27.7094 17.0994 27.8198L17.2763 29.9131C18.87 29.7784 20.3343 29.3055 21.4631 28.5959C22.5698 27.9003 23.4839 26.8869 23.6779 25.6289L21.6017 25.3087ZM22.6103 24.4172L22.5513 24.4222L22.7282 26.5155L22.7872 26.5105L22.6103 24.4172ZM20.7486 14.8615L21.6521 25.5523L23.7454 25.3754L22.8419 14.6846L20.7486 14.8615Z",
    fill: "#CA0000",
    mask: "url(#path-4-inside-1_3549_10785)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    x: 11.4453,
    y: 16.7041,
    width: 2.10077,
    height: 7.3527,
    transform: "rotate(-4.83078 11.4453 16.7041)",
    fill: "#EB7654"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1",
    d: "M25.0031 8.70565C25.3359 12.6435 21.5269 16.3784 16.2024 16.8283C10.8779 17.2783 6.49611 14.2357 6.16331 10.2979C5.83051 6.36005 9.63949 2.62517 14.964 2.17518C20.2885 1.72519 24.6703 4.76783 25.0031 8.70565Z",
    fill: "#E23724",
    stroke: "#CA0000",
    strokeWidth: 1.05039
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2",
    cx: 11.8322,
    cy: 8.76259,
    rx: 4.20154,
    ry: 3.67635,
    transform: "rotate(-4.83078 11.8322 8.76259)",
    fill: "#EB7654"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3549_10785",
    x: 0.898438,
    y: 1.60645,
    width: 32.1133,
    height: 54.0498,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3549_10785"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3549_10785",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedPin);
export default __webpack_public_path__ + "static/media/Red Pin.23341b425ea92b8c869f663756d4c1a3.svg";
export { ForwardRef as ReactComponent };